import actionTypes from '../actionTypes';

export function requestGames(isMobile) {
  return {
    type: actionTypes.GAMES_REQUEST,
    isMobile
  };
}

export function successGames(data) {
  return {
    type: actionTypes.GAMES_SUCCESS,
    value: data,
  };
}
export function failGames(e) {
  return {
    type: actionTypes.GAMES_FAIL,
    exception: e,
  };
}

export function successProviders(data) {
  return {
    type: actionTypes.PROVIDERS_SUCCESS,
    value: data,
  };
}

export function successProductsTypes(data) {
  return {
    type: actionTypes.PRODUCTS_TYPES_SUCCESS,
    value: data,
  };
}

export function successGameTags(data) {
  return {
    type: actionTypes.GAME_TAGS_SUCCESS,
    value: data
  };
}